import React, { useEffect, useState } from "react";
import {
  getTemplateQuestions,
  getTemplates,
  updateQuestion,
} from "../../api/TemplateApi";
import { appTitle } from "../common/GeneralConfigurations";
import TemplateListForm from "./TemplateListForm";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import { useTranslation } from "react-i18next";

function ManageTemplateListPage() {
  const [data, setData] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${appTitle} - ${t("template.title")}`;
  }, [t]);

  useEffect(() => {
    getTemplates().then((res) => {
      setLoading(false);
      setData(res.data);
    });
  }, []);

  const handleUpdate = async (values) => {
    setSubmitLoading(true);
    currentQuestion.question = values.question;
    await updateQuestion(currentQuestion);
    setVisible(false);
    setSubmitLoading(false);
    AdnMessageSuccess();
  };

  const handleChange = async (value) => {
    await getTemplateQuestions(value).then((res) => setQuestions(res.data));
  };
  return (
    <>
      <TemplateListForm
        options={data}
        placeholder={t("template.placeholders.selectTemplate")}
        handleChange={handleChange}
        handleUpdate={handleUpdate}
        questions={questions}
        visible={visible}
        setVisible={setVisible}
        setCurrentQuestion={setCurrentQuestion}
        currentQuestion={currentQuestion}
        loading={loading}
        submitLoading={submitLoading}
      />
    </>
  );
}

export default ManageTemplateListPage;
